import { render } from "./03-AskForGeolocationPermissions.vue?vue&type=template&id=5d15a84f"
import script from "./03-AskForGeolocationPermissions.vue?vue&type=script&lang=js"
export * from "./03-AskForGeolocationPermissions.vue?vue&type=script&lang=js"

import exportComponent from "/home/randreu/projects/gringo/UPlanner/QRAsistencia/apps/qr-asistencia/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__